import { TToggleInviteStatus } from "../../models";
import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export default async ({ inviteToken, inviteId }: TToggleInviteStatus = {}) => {
    const tempHeaders = {
        auth: true,
        "x-invite-token": inviteToken,
        "x-invite-id": inviteId,
    };

    if (!inviteToken) delete tempHeaders["x-invite-token"];
    if (!inviteId) delete tempHeaders["x-invite-id"];

    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/invite/toggleStatus`,
        method: "patch",
        headers: tempHeaders,
    });
    const { body, statusCode } = httpResponse;

    const errorFeedBacks = {
        400: "Convite inválido",
        409: "Usuário já existente/convite já existe para este usuário!",
        500: "Email não verificado",
    };

    return handleStatusCases({
        body,
        statusCode,
        errorFeedBacks,
    });
};
